<!--
 * Path: src/features/browser/forms/icon/IconEdit.vue
 * Task: Editable input field for assigning Material Design Icons.
-->
<template>
  <div class="d-flex align-center">
    <v-avatar :color="entityColor" size="40" class="me-3 flex-shrink-0 elevation-1" style="border-radius: 10px; border: 1px solid rgba(128,128,128,0.2);">
      <v-icon color="white">{{ modelValue || defaultIcon }}</v-icon>
    </v-avatar>
    <v-text-field
      v-model="modelValue"
      variant="outlined"
      density="compact"
      hide-details
      class="flex-grow-1"
      placeholder="e.g. mdi-account-group"
    >
      <template v-slot:append-inner>
        <v-btn
          v-if="mdiLibraryUrl"
          icon
          variant="text"
          density="compact"
          size="small"
          color="medium-emphasis"
          @mousedown.stop
          @click.stop="openMdiLibrary"
        >
          <v-icon>mdi-information-outline</v-icon>
          <v-tooltip activator="parent" location="top">Open Material Design Icons</v-tooltip>
        </v-btn>
      </template>
    </v-text-field>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAuthStore } from '@/store/auth';

interface Props {
  defaultIcon?: string;
  entityColor?: string;
}

withDefaults(defineProps<Props>(), {
  defaultIcon: 'mdi-shape',
  entityColor: 'grey'
});

const modelValue = defineModel<string>({ default: '' });
const authStore = useAuthStore();

const mdiLibraryUrl = computed(() => authStore.appData?.mdiLibraryUrl || 'https://pictogrammers.com/library/mdi/');

const openMdiLibrary = () => {
  if (mdiLibraryUrl.value) {
    window.open(mdiLibraryUrl.value, '_blank');
  }
};
</script>
